
























import Vue from 'vue'
import DatePicker from '@/components/Global/DatePicker.vue'
import moment from 'moment'

export default Vue.extend({
  name: 'Toolbar',
  components: { DatePicker },
  props: {
    entityList: Array,
    loadingEntities: Boolean,
    loadingUsers: Boolean

  },
  data: () => ({
    range: {
      from: '',
      till: ''
    },
    selectedEntity: null,
    selectedUser: null
  }),
  methods: {
    checkDates (value: any) {
      const range = { from: '2021-05-27', to: '2021-07-31' }

      const notice = moment(value.from).isBetween(range.from, range.to) || moment(value.to).isBetween(range.from, range.to)
      this.$emit('showNotice', notice)
    },
    getTrips (): void {
      const { from, till } = this.range
      const addDayToTill = { from, till: moment(till).add(0, 'day').format('YYYY-MM-DD') }
      const hasValidDates = Object.values(addDayToTill).some(d => d === 'Invalid date')

      if (!hasValidDates) {
        this.$emit('getTrips', {
          selectedUser: this.selectedUser,
          selectedEntity: this.selectedEntity,
          range: addDayToTill
        })
      }
    }
  }
})
